// source: io/codedrills/proto/user/user.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_judge_judge_pb = require('../../../../io/codedrills/proto/judge/judge_pb.js');
goog.object.extend(proto, io_codedrills_proto_judge_judge_pb);
var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_preview_pb);
goog.exportSymbol('proto.io.codedrills.proto.user.Activity', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ActivityData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ActivityStatus', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Address', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.AdminProfile', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.AdminRole', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CPVerification', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CPVerificationType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Career', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CompetitiveProfile', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CompetitiveSite', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ContestStats', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Degree', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.DrillReport', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.EditorConfig', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Education', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Experience', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.MailingList', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.NewUser', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.NewUserType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Preference', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ProblemReport', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Profile', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ProfileChange', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ProfileChange.ProfileChangeMessageCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.PublicProfile', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Role', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Scope', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Scopes', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ScoreboardCompleted', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.SendNewUserEmail', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.SendNewUserEmail.InviteInfoCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Skill', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Skills', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.SocialProfile', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.SocialProfileType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.SubscribeGroup', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.SubscriptionSettings', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.TestProblemScore', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.User', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.UserAddress', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.UserAddress.UseraddressCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.User.displayName = 'proto.io.codedrills.proto.user.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.AdminProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.AdminProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.AdminProfile.displayName = 'proto.io.codedrills.proto.user.AdminProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.UserAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.user.UserAddress.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.user.UserAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.UserAddress.displayName = 'proto.io.codedrills.proto.user.UserAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Profile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.Profile.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.Profile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Profile.displayName = 'proto.io.codedrills.proto.user.Profile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.PublicProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.PublicProfile.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.PublicProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.PublicProfile.displayName = 'proto.io.codedrills.proto.user.PublicProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.ContestStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.ContestStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.ContestStats.displayName = 'proto.io.codedrills.proto.user.ContestStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CompetitiveProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.CompetitiveProfile.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.CompetitiveProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CompetitiveProfile.displayName = 'proto.io.codedrills.proto.user.CompetitiveProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CPVerification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CPVerification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CPVerification.displayName = 'proto.io.codedrills.proto.user.CPVerification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.SocialProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.SocialProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.SocialProfile.displayName = 'proto.io.codedrills.proto.user.SocialProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Address = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Address, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Address.displayName = 'proto.io.codedrills.proto.user.Address';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Career = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.Career.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.Career, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Career.displayName = 'proto.io.codedrills.proto.user.Career';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Skills = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.Skills.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.Skills, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Skills.displayName = 'proto.io.codedrills.proto.user.Skills';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Skill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Skill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Skill.displayName = 'proto.io.codedrills.proto.user.Skill';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Education = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.Education.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.Education, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Education.displayName = 'proto.io.codedrills.proto.user.Education';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Scopes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.Scopes.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.Scopes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Scopes.displayName = 'proto.io.codedrills.proto.user.Scopes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Experience = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Experience, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Experience.displayName = 'proto.io.codedrills.proto.user.Experience';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Degree = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Degree, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Degree.displayName = 'proto.io.codedrills.proto.user.Degree';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Preference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Preference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Preference.displayName = 'proto.io.codedrills.proto.user.Preference';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.EditorConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.EditorConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.EditorConfig.displayName = 'proto.io.codedrills.proto.user.EditorConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.SubscriptionSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.SubscriptionSettings.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.SubscriptionSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.SubscriptionSettings.displayName = 'proto.io.codedrills.proto.user.SubscriptionSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Activity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Activity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Activity.displayName = 'proto.io.codedrills.proto.user.Activity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.ActivityData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.ActivityData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.ActivityData.displayName = 'proto.io.codedrills.proto.user.ActivityData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.DrillReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.DrillReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.DrillReport.displayName = 'proto.io.codedrills.proto.user.DrillReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.ProblemReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.ProblemReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.ProblemReport.displayName = 'proto.io.codedrills.proto.user.ProblemReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.TestProblemScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.TestProblemScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.TestProblemScore.displayName = 'proto.io.codedrills.proto.user.TestProblemScore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.ProfileChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.user.ProfileChange.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.user.ProfileChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.ProfileChange.displayName = 'proto.io.codedrills.proto.user.ProfileChange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.ScoreboardCompleted = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.ScoreboardCompleted, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.ScoreboardCompleted.displayName = 'proto.io.codedrills.proto.user.ScoreboardCompleted';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.SendNewUserEmail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.user.SendNewUserEmail.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.user.SendNewUserEmail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.SendNewUserEmail.displayName = 'proto.io.codedrills.proto.user.SendNewUserEmail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.NewUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.NewUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.NewUser.displayName = 'proto.io.codedrills.proto.user.NewUser';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.User.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phoneNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    role: jspb.Message.getFieldWithDefault(msg, 5, 0),
    scopes: (f = msg.getScopes()) && proto.io.codedrills.proto.user.Scopes.toObject(includeInstance, f),
    profile: (f = msg.getProfile()) && proto.io.codedrills.proto.user.Profile.toObject(includeInstance, f),
    preference: (f = msg.getPreference()) && proto.io.codedrills.proto.user.Preference.toObject(includeInstance, f),
    handle: jspb.Message.getFieldWithDefault(msg, 10, ""),
    rating: jspb.Message.getFieldWithDefault(msg, 11, 0),
    joinedOn: jspb.Message.getFieldWithDefault(msg, 12, 0),
    customerId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    adminProfile: (f = msg.getAdminProfile()) && proto.io.codedrills.proto.user.AdminProfile.toObject(includeInstance, f),
    adminRole: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.User}
 */
proto.io.codedrills.proto.user.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.User;
  return proto.io.codedrills.proto.user.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.User}
 */
proto.io.codedrills.proto.user.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNo(value);
      break;
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.user.Role} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.user.Scopes;
      reader.readMessage(value,proto.io.codedrills.proto.user.Scopes.deserializeBinaryFromReader);
      msg.setScopes(value);
      break;
    case 7:
      var value = new proto.io.codedrills.proto.user.Profile;
      reader.readMessage(value,proto.io.codedrills.proto.user.Profile.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 8:
      var value = new proto.io.codedrills.proto.user.Preference;
      reader.readMessage(value,proto.io.codedrills.proto.user.Preference.deserializeBinaryFromReader);
      msg.setPreference(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHandle(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRating(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setJoinedOn(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    case 14:
      var value = new proto.io.codedrills.proto.user.AdminProfile;
      reader.readMessage(value,proto.io.codedrills.proto.user.AdminProfile.deserializeBinaryFromReader);
      msg.setAdminProfile(value);
      break;
    case 15:
      var value = /** @type {!proto.io.codedrills.proto.user.AdminRole} */ (reader.readEnum());
      msg.setAdminRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhoneNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getScopes();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.user.Scopes.serializeBinaryToWriter
    );
  }
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.io.codedrills.proto.user.Profile.serializeBinaryToWriter
    );
  }
  f = message.getPreference();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.io.codedrills.proto.user.Preference.serializeBinaryToWriter
    );
  }
  f = message.getHandle();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getRating();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getJoinedOn();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getAdminProfile();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.io.codedrills.proto.user.AdminProfile.serializeBinaryToWriter
    );
  }
  f = message.getAdminRole();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.User.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.User.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.User.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string phone_no = 4;
 * @return {string}
 */
proto.io.codedrills.proto.user.User.prototype.getPhoneNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setPhoneNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional Role role = 5;
 * @return {!proto.io.codedrills.proto.user.Role}
 */
proto.io.codedrills.proto.user.User.prototype.getRole = function() {
  return /** @type {!proto.io.codedrills.proto.user.Role} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.Role} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Scopes scopes = 6;
 * @return {?proto.io.codedrills.proto.user.Scopes}
 */
proto.io.codedrills.proto.user.User.prototype.getScopes = function() {
  return /** @type{?proto.io.codedrills.proto.user.Scopes} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.Scopes, 6));
};


/**
 * @param {?proto.io.codedrills.proto.user.Scopes|undefined} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
*/
proto.io.codedrills.proto.user.User.prototype.setScopes = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.clearScopes = function() {
  return this.setScopes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.User.prototype.hasScopes = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Profile profile = 7;
 * @return {?proto.io.codedrills.proto.user.Profile}
 */
proto.io.codedrills.proto.user.User.prototype.getProfile = function() {
  return /** @type{?proto.io.codedrills.proto.user.Profile} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.Profile, 7));
};


/**
 * @param {?proto.io.codedrills.proto.user.Profile|undefined} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
*/
proto.io.codedrills.proto.user.User.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.User.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Preference preference = 8;
 * @return {?proto.io.codedrills.proto.user.Preference}
 */
proto.io.codedrills.proto.user.User.prototype.getPreference = function() {
  return /** @type{?proto.io.codedrills.proto.user.Preference} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.Preference, 8));
};


/**
 * @param {?proto.io.codedrills.proto.user.Preference|undefined} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
*/
proto.io.codedrills.proto.user.User.prototype.setPreference = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.clearPreference = function() {
  return this.setPreference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.User.prototype.hasPreference = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string handle = 10;
 * @return {string}
 */
proto.io.codedrills.proto.user.User.prototype.getHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setHandle = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 rating = 11;
 * @return {number}
 */
proto.io.codedrills.proto.user.User.prototype.getRating = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setRating = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 joined_on = 12;
 * @return {number}
 */
proto.io.codedrills.proto.user.User.prototype.getJoinedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setJoinedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 customer_id = 13;
 * @return {number}
 */
proto.io.codedrills.proto.user.User.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional AdminProfile admin_profile = 14;
 * @return {?proto.io.codedrills.proto.user.AdminProfile}
 */
proto.io.codedrills.proto.user.User.prototype.getAdminProfile = function() {
  return /** @type{?proto.io.codedrills.proto.user.AdminProfile} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.AdminProfile, 14));
};


/**
 * @param {?proto.io.codedrills.proto.user.AdminProfile|undefined} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
*/
proto.io.codedrills.proto.user.User.prototype.setAdminProfile = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.clearAdminProfile = function() {
  return this.setAdminProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.User.prototype.hasAdminProfile = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional AdminRole admin_role = 15;
 * @return {!proto.io.codedrills.proto.user.AdminRole}
 */
proto.io.codedrills.proto.user.User.prototype.getAdminRole = function() {
  return /** @type {!proto.io.codedrills.proto.user.AdminRole} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.AdminRole} value
 * @return {!proto.io.codedrills.proto.user.User} returns this
 */
proto.io.codedrills.proto.user.User.prototype.setAdminRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.AdminProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.AdminProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.AdminProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.AdminProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
    position: jspb.Message.getFieldWithDefault(msg, 1, ""),
    about: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.AdminProfile}
 */
proto.io.codedrills.proto.user.AdminProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.AdminProfile;
  return proto.io.codedrills.proto.user.AdminProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.AdminProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.AdminProfile}
 */
proto.io.codedrills.proto.user.AdminProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPosition(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.AdminProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.AdminProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.AdminProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.AdminProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosition();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAbout();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string position = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.AdminProfile.prototype.getPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.AdminProfile} returns this
 */
proto.io.codedrills.proto.user.AdminProfile.prototype.setPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string about = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.AdminProfile.prototype.getAbout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.AdminProfile} returns this
 */
proto.io.codedrills.proto.user.AdminProfile.prototype.setAbout = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.user.UserAddress.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.UserAddress.UseraddressCase = {
  USERADDRESS_NOT_SET: 0,
  ID: 1,
  EMAIL: 2,
  HANDLE: 3
};

/**
 * @return {proto.io.codedrills.proto.user.UserAddress.UseraddressCase}
 */
proto.io.codedrills.proto.user.UserAddress.prototype.getUseraddressCase = function() {
  return /** @type {proto.io.codedrills.proto.user.UserAddress.UseraddressCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.user.UserAddress.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.UserAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.UserAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.UserAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.UserAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    handle: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.UserAddress}
 */
proto.io.codedrills.proto.user.UserAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.UserAddress;
  return proto.io.codedrills.proto.user.UserAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.UserAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.UserAddress}
 */
proto.io.codedrills.proto.user.UserAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHandle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.UserAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.UserAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.UserAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.UserAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.UserAddress.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.UserAddress} returns this
 */
proto.io.codedrills.proto.user.UserAddress.prototype.setId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.user.UserAddress.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.UserAddress} returns this
 */
proto.io.codedrills.proto.user.UserAddress.prototype.clearId = function() {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.user.UserAddress.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.UserAddress.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.UserAddress.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.UserAddress} returns this
 */
proto.io.codedrills.proto.user.UserAddress.prototype.setEmail = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.user.UserAddress.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.UserAddress} returns this
 */
proto.io.codedrills.proto.user.UserAddress.prototype.clearEmail = function() {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.user.UserAddress.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.UserAddress.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string handle = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.UserAddress.prototype.getHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.UserAddress} returns this
 */
proto.io.codedrills.proto.user.UserAddress.prototype.setHandle = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.io.codedrills.proto.user.UserAddress.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.UserAddress} returns this
 */
proto.io.codedrills.proto.user.UserAddress.prototype.clearHandle = function() {
  return jspb.Message.setOneofField(this, 3, proto.io.codedrills.proto.user.UserAddress.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.UserAddress.prototype.hasHandle = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.Profile.repeatedFields_ = [6,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Profile.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Profile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Profile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Profile.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: (f = msg.getAddress()) && proto.io.codedrills.proto.user.Address.toObject(includeInstance, f),
    career: (f = msg.getCareer()) && proto.io.codedrills.proto.user.Career.toObject(includeInstance, f),
    education: (f = msg.getEducation()) && proto.io.codedrills.proto.user.Education.toObject(includeInstance, f),
    skills: (f = msg.getSkills()) && proto.io.codedrills.proto.user.Skills.toObject(includeInstance, f),
    about: jspb.Message.getFieldWithDefault(msg, 5, ""),
    competitiveProfilesList: jspb.Message.toObjectList(msg.getCompetitiveProfilesList(),
    proto.io.codedrills.proto.user.CompetitiveProfile.toObject, includeInstance),
    socialProfile: (f = msg.getSocialProfile()) && proto.io.codedrills.proto.user.SocialProfile.toObject(includeInstance, f),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
    contestStatsList: jspb.Message.toObjectList(msg.getContestStatsList(),
    proto.io.codedrills.proto.user.ContestStats.toObject, includeInstance),
    problemsSolved: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Profile}
 */
proto.io.codedrills.proto.user.Profile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Profile;
  return proto.io.codedrills.proto.user.Profile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Profile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Profile}
 */
proto.io.codedrills.proto.user.Profile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.Address;
      reader.readMessage(value,proto.io.codedrills.proto.user.Address.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.user.Career;
      reader.readMessage(value,proto.io.codedrills.proto.user.Career.deserializeBinaryFromReader);
      msg.setCareer(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.user.Education;
      reader.readMessage(value,proto.io.codedrills.proto.user.Education.deserializeBinaryFromReader);
      msg.setEducation(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.user.Skills;
      reader.readMessage(value,proto.io.codedrills.proto.user.Skills.deserializeBinaryFromReader);
      msg.setSkills(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbout(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.user.CompetitiveProfile;
      reader.readMessage(value,proto.io.codedrills.proto.user.CompetitiveProfile.deserializeBinaryFromReader);
      msg.addCompetitiveProfiles(value);
      break;
    case 7:
      var value = new proto.io.codedrills.proto.user.SocialProfile;
      reader.readMessage(value,proto.io.codedrills.proto.user.SocialProfile.deserializeBinaryFromReader);
      msg.setSocialProfile(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 9:
      var value = new proto.io.codedrills.proto.user.ContestStats;
      reader.readMessage(value,proto.io.codedrills.proto.user.ContestStats.deserializeBinaryFromReader);
      msg.addContestStats(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemsSolved(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Profile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Profile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Profile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Profile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.user.Address.serializeBinaryToWriter
    );
  }
  f = message.getCareer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.user.Career.serializeBinaryToWriter
    );
  }
  f = message.getEducation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.user.Education.serializeBinaryToWriter
    );
  }
  f = message.getSkills();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.io.codedrills.proto.user.Skills.serializeBinaryToWriter
    );
  }
  f = message.getAbout();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCompetitiveProfilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.io.codedrills.proto.user.CompetitiveProfile.serializeBinaryToWriter
    );
  }
  f = message.getSocialProfile();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.io.codedrills.proto.user.SocialProfile.serializeBinaryToWriter
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getContestStatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.io.codedrills.proto.user.ContestStats.serializeBinaryToWriter
    );
  }
  f = message.getProblemsSolved();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional Address address = 1;
 * @return {?proto.io.codedrills.proto.user.Address}
 */
proto.io.codedrills.proto.user.Profile.prototype.getAddress = function() {
  return /** @type{?proto.io.codedrills.proto.user.Address} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.Address, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.Address|undefined} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
*/
proto.io.codedrills.proto.user.Profile.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Profile.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Career career = 2;
 * @return {?proto.io.codedrills.proto.user.Career}
 */
proto.io.codedrills.proto.user.Profile.prototype.getCareer = function() {
  return /** @type{?proto.io.codedrills.proto.user.Career} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.Career, 2));
};


/**
 * @param {?proto.io.codedrills.proto.user.Career|undefined} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
*/
proto.io.codedrills.proto.user.Profile.prototype.setCareer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.clearCareer = function() {
  return this.setCareer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Profile.prototype.hasCareer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Education education = 3;
 * @return {?proto.io.codedrills.proto.user.Education}
 */
proto.io.codedrills.proto.user.Profile.prototype.getEducation = function() {
  return /** @type{?proto.io.codedrills.proto.user.Education} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.Education, 3));
};


/**
 * @param {?proto.io.codedrills.proto.user.Education|undefined} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
*/
proto.io.codedrills.proto.user.Profile.prototype.setEducation = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.clearEducation = function() {
  return this.setEducation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Profile.prototype.hasEducation = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Skills skills = 4;
 * @return {?proto.io.codedrills.proto.user.Skills}
 */
proto.io.codedrills.proto.user.Profile.prototype.getSkills = function() {
  return /** @type{?proto.io.codedrills.proto.user.Skills} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.Skills, 4));
};


/**
 * @param {?proto.io.codedrills.proto.user.Skills|undefined} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
*/
proto.io.codedrills.proto.user.Profile.prototype.setSkills = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.clearSkills = function() {
  return this.setSkills(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Profile.prototype.hasSkills = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string about = 5;
 * @return {string}
 */
proto.io.codedrills.proto.user.Profile.prototype.getAbout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.setAbout = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated CompetitiveProfile competitive_profiles = 6;
 * @return {!Array<!proto.io.codedrills.proto.user.CompetitiveProfile>}
 */
proto.io.codedrills.proto.user.Profile.prototype.getCompetitiveProfilesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.CompetitiveProfile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.CompetitiveProfile, 6));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.CompetitiveProfile>} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
*/
proto.io.codedrills.proto.user.Profile.prototype.setCompetitiveProfilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.CompetitiveProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile}
 */
proto.io.codedrills.proto.user.Profile.prototype.addCompetitiveProfiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.io.codedrills.proto.user.CompetitiveProfile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.clearCompetitiveProfilesList = function() {
  return this.setCompetitiveProfilesList([]);
};


/**
 * optional SocialProfile social_profile = 7;
 * @return {?proto.io.codedrills.proto.user.SocialProfile}
 */
proto.io.codedrills.proto.user.Profile.prototype.getSocialProfile = function() {
  return /** @type{?proto.io.codedrills.proto.user.SocialProfile} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.SocialProfile, 7));
};


/**
 * @param {?proto.io.codedrills.proto.user.SocialProfile|undefined} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
*/
proto.io.codedrills.proto.user.Profile.prototype.setSocialProfile = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.clearSocialProfile = function() {
  return this.setSocialProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Profile.prototype.hasSocialProfile = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string image_url = 8;
 * @return {string}
 */
proto.io.codedrills.proto.user.Profile.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated ContestStats contest_stats = 9;
 * @return {!Array<!proto.io.codedrills.proto.user.ContestStats>}
 */
proto.io.codedrills.proto.user.Profile.prototype.getContestStatsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.ContestStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.ContestStats, 9));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.ContestStats>} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
*/
proto.io.codedrills.proto.user.Profile.prototype.setContestStatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.ContestStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.ContestStats}
 */
proto.io.codedrills.proto.user.Profile.prototype.addContestStats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.io.codedrills.proto.user.ContestStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.clearContestStatsList = function() {
  return this.setContestStatsList([]);
};


/**
 * optional int32 problems_solved = 10;
 * @return {number}
 */
proto.io.codedrills.proto.user.Profile.prototype.getProblemsSolved = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Profile} returns this
 */
proto.io.codedrills.proto.user.Profile.prototype.setProblemsSolved = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.PublicProfile.repeatedFields_ = [2,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.PublicProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.PublicProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.PublicProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
    about: jspb.Message.getFieldWithDefault(msg, 1, ""),
    competitiveProfilesList: jspb.Message.toObjectList(msg.getCompetitiveProfilesList(),
    proto.io.codedrills.proto.user.CompetitiveProfile.toObject, includeInstance),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    contestStatsList: jspb.Message.toObjectList(msg.getContestStatsList(),
    proto.io.codedrills.proto.user.ContestStats.toObject, includeInstance),
    problemsSolved: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.PublicProfile}
 */
proto.io.codedrills.proto.user.PublicProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.PublicProfile;
  return proto.io.codedrills.proto.user.PublicProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.PublicProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.PublicProfile}
 */
proto.io.codedrills.proto.user.PublicProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbout(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.user.CompetitiveProfile;
      reader.readMessage(value,proto.io.codedrills.proto.user.CompetitiveProfile.deserializeBinaryFromReader);
      msg.addCompetitiveProfiles(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.user.ContestStats;
      reader.readMessage(value,proto.io.codedrills.proto.user.ContestStats.deserializeBinaryFromReader);
      msg.addContestStats(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemsSolved(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.PublicProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.PublicProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.PublicProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAbout();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompetitiveProfilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.user.CompetitiveProfile.serializeBinaryToWriter
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContestStatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.io.codedrills.proto.user.ContestStats.serializeBinaryToWriter
    );
  }
  f = message.getProblemsSolved();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string about = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.getAbout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.PublicProfile} returns this
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.setAbout = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated CompetitiveProfile competitive_profiles = 2;
 * @return {!Array<!proto.io.codedrills.proto.user.CompetitiveProfile>}
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.getCompetitiveProfilesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.CompetitiveProfile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.CompetitiveProfile, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.CompetitiveProfile>} value
 * @return {!proto.io.codedrills.proto.user.PublicProfile} returns this
*/
proto.io.codedrills.proto.user.PublicProfile.prototype.setCompetitiveProfilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.CompetitiveProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile}
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.addCompetitiveProfiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.user.CompetitiveProfile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.PublicProfile} returns this
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.clearCompetitiveProfilesList = function() {
  return this.setCompetitiveProfilesList([]);
};


/**
 * optional string image_url = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.PublicProfile} returns this
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ContestStats contest_stats = 4;
 * @return {!Array<!proto.io.codedrills.proto.user.ContestStats>}
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.getContestStatsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.ContestStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.ContestStats, 4));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.ContestStats>} value
 * @return {!proto.io.codedrills.proto.user.PublicProfile} returns this
*/
proto.io.codedrills.proto.user.PublicProfile.prototype.setContestStatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.ContestStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.ContestStats}
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.addContestStats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.io.codedrills.proto.user.ContestStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.PublicProfile} returns this
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.clearContestStatsList = function() {
  return this.setContestStatsList([]);
};


/**
 * optional int32 problems_solved = 5;
 * @return {number}
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.getProblemsSolved = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.PublicProfile} returns this
 */
proto.io.codedrills.proto.user.PublicProfile.prototype.setProblemsSolved = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.ContestStats.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.ContestStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.ContestStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ContestStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    contestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rank: jspb.Message.getFieldWithDefault(msg, 2, 0),
    problemSolved: jspb.Message.getFieldWithDefault(msg, 3, 0),
    contentPreview: (f = msg.getContentPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.ContestStats}
 */
proto.io.codedrills.proto.user.ContestStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.ContestStats;
  return proto.io.codedrills.proto.user.ContestStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.ContestStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.ContestStats}
 */
proto.io.codedrills.proto.user.ContestStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemSolved(value);
      break;
    case 4:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setContentPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.ContestStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.ContestStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.ContestStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ContestStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContestId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getProblemSolved();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getContentPreview();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 contest_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.ContestStats.prototype.getContestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ContestStats} returns this
 */
proto.io.codedrills.proto.user.ContestStats.prototype.setContestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 rank = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.ContestStats.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ContestStats} returns this
 */
proto.io.codedrills.proto.user.ContestStats.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 problem_solved = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.ContestStats.prototype.getProblemSolved = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ContestStats} returns this
 */
proto.io.codedrills.proto.user.ContestStats.prototype.setProblemSolved = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional io.codedrills.proto.content.ContentPreview content_preview = 4;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.user.ContestStats.prototype.getContentPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.user.ContestStats} returns this
*/
proto.io.codedrills.proto.user.ContestStats.prototype.setContentPreview = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.ContestStats} returns this
 */
proto.io.codedrills.proto.user.ContestStats.prototype.clearContentPreview = function() {
  return this.setContentPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.ContestStats.prototype.hasContentPreview = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.CompetitiveProfile.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CompetitiveProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CompetitiveProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompetitiveProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
    competitiveSite: jspb.Message.getFieldWithDefault(msg, 1, 0),
    handle: jspb.Message.getFieldWithDefault(msg, 2, ""),
    verified: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    verificationList: jspb.Message.toObjectList(msg.getVerificationList(),
    proto.io.codedrills.proto.user.CPVerification.toObject, includeInstance),
    rating: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    solvedProblems: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CompetitiveProfile;
  return proto.io.codedrills.proto.user.CompetitiveProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CompetitiveProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.user.CompetitiveSite} */ (reader.readEnum());
      msg.setCompetitiveSite(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHandle(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.user.CPVerification;
      reader.readMessage(value,proto.io.codedrills.proto.user.CPVerification.deserializeBinaryFromReader);
      msg.addVerification(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRating(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSolvedProblems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CompetitiveProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CompetitiveProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CompetitiveProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompetitiveSite();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getHandle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getVerificationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.io.codedrills.proto.user.CPVerification.serializeBinaryToWriter
    );
  }
  f = message.getRating();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getSolvedProblems();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional CompetitiveSite competitive_site = 1;
 * @return {!proto.io.codedrills.proto.user.CompetitiveSite}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.getCompetitiveSite = function() {
  return /** @type {!proto.io.codedrills.proto.user.CompetitiveSite} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.CompetitiveSite} value
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile} returns this
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.setCompetitiveSite = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string handle = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.getHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile} returns this
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.setHandle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool verified = 3;
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile} returns this
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.setVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated CPVerification verification = 4;
 * @return {!Array<!proto.io.codedrills.proto.user.CPVerification>}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.getVerificationList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.CPVerification>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.CPVerification, 4));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.CPVerification>} value
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile} returns this
*/
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.setVerificationList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.CPVerification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.CPVerification}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.addVerification = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.io.codedrills.proto.user.CPVerification, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile} returns this
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.clearVerificationList = function() {
  return this.setVerificationList([]);
};


/**
 * optional double rating = 5;
 * @return {number}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.getRating = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile} returns this
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.setRating = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int32 solved_problems = 6;
 * @return {number}
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.getSolvedProblems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CompetitiveProfile} returns this
 */
proto.io.codedrills.proto.user.CompetitiveProfile.prototype.setSolvedProblems = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CPVerification.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CPVerification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CPVerification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CPVerification.toObject = function(includeInstance, msg) {
  var f, obj = {
    verificationType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    url: jspb.Message.getFieldWithDefault(msg, 2, ""),
    codeLanguage: jspb.Message.getFieldWithDefault(msg, 3, ""),
    verificationString: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CPVerification}
 */
proto.io.codedrills.proto.user.CPVerification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CPVerification;
  return proto.io.codedrills.proto.user.CPVerification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CPVerification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CPVerification}
 */
proto.io.codedrills.proto.user.CPVerification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.user.CPVerificationType} */ (reader.readEnum());
      msg.setVerificationType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCodeLanguage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationString(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CPVerification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CPVerification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CPVerification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CPVerification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCodeLanguage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVerificationString();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CPVerificationType verification_type = 1;
 * @return {!proto.io.codedrills.proto.user.CPVerificationType}
 */
proto.io.codedrills.proto.user.CPVerification.prototype.getVerificationType = function() {
  return /** @type {!proto.io.codedrills.proto.user.CPVerificationType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.CPVerificationType} value
 * @return {!proto.io.codedrills.proto.user.CPVerification} returns this
 */
proto.io.codedrills.proto.user.CPVerification.prototype.setVerificationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.CPVerification.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CPVerification} returns this
 */
proto.io.codedrills.proto.user.CPVerification.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string code_language = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.CPVerification.prototype.getCodeLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CPVerification} returns this
 */
proto.io.codedrills.proto.user.CPVerification.prototype.setCodeLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string verification_string = 4;
 * @return {string}
 */
proto.io.codedrills.proto.user.CPVerification.prototype.getVerificationString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CPVerification} returns this
 */
proto.io.codedrills.proto.user.CPVerification.prototype.setVerificationString = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.SocialProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.SocialProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.SocialProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SocialProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
    socialProfileType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    url: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.SocialProfile}
 */
proto.io.codedrills.proto.user.SocialProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.SocialProfile;
  return proto.io.codedrills.proto.user.SocialProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.SocialProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.SocialProfile}
 */
proto.io.codedrills.proto.user.SocialProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.user.SocialProfileType} */ (reader.readEnum());
      msg.setSocialProfileType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.SocialProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.SocialProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.SocialProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SocialProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSocialProfileType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional SocialProfileType social_profile_type = 1;
 * @return {!proto.io.codedrills.proto.user.SocialProfileType}
 */
proto.io.codedrills.proto.user.SocialProfile.prototype.getSocialProfileType = function() {
  return /** @type {!proto.io.codedrills.proto.user.SocialProfileType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.SocialProfileType} value
 * @return {!proto.io.codedrills.proto.user.SocialProfile} returns this
 */
proto.io.codedrills.proto.user.SocialProfile.prototype.setSocialProfileType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.SocialProfile.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.SocialProfile} returns this
 */
proto.io.codedrills.proto.user.SocialProfile.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Address.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Address.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Address.toObject = function(includeInstance, msg) {
  var f, obj = {
    cityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    countryId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Address}
 */
proto.io.codedrills.proto.user.Address.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Address;
  return proto.io.codedrills.proto.user.Address.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Address}
 */
proto.io.codedrills.proto.user.Address.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Address.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Address.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Address.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountryId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string city_id = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.Address.prototype.getCityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Address} returns this
 */
proto.io.codedrills.proto.user.Address.prototype.setCityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string country_id = 4;
 * @return {string}
 */
proto.io.codedrills.proto.user.Address.prototype.getCountryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Address} returns this
 */
proto.io.codedrills.proto.user.Address.prototype.setCountryId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.Career.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Career.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Career.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Career} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Career.toObject = function(includeInstance, msg) {
  var f, obj = {
    experiencesList: jspb.Message.toObjectList(msg.getExperiencesList(),
    proto.io.codedrills.proto.user.Experience.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Career}
 */
proto.io.codedrills.proto.user.Career.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Career;
  return proto.io.codedrills.proto.user.Career.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Career} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Career}
 */
proto.io.codedrills.proto.user.Career.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.Experience;
      reader.readMessage(value,proto.io.codedrills.proto.user.Experience.deserializeBinaryFromReader);
      msg.addExperiences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Career.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Career.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Career} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Career.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperiencesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.io.codedrills.proto.user.Experience.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Experience experiences = 1;
 * @return {!Array<!proto.io.codedrills.proto.user.Experience>}
 */
proto.io.codedrills.proto.user.Career.prototype.getExperiencesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.Experience>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.Experience, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.Experience>} value
 * @return {!proto.io.codedrills.proto.user.Career} returns this
*/
proto.io.codedrills.proto.user.Career.prototype.setExperiencesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.Experience=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Experience}
 */
proto.io.codedrills.proto.user.Career.prototype.addExperiences = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.user.Experience, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Career} returns this
 */
proto.io.codedrills.proto.user.Career.prototype.clearExperiencesList = function() {
  return this.setExperiencesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.Skills.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Skills.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Skills.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Skills} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Skills.toObject = function(includeInstance, msg) {
  var f, obj = {
    languageSkillsList: jspb.Message.toObjectList(msg.getLanguageSkillsList(),
    proto.io.codedrills.proto.user.Skill.toObject, includeInstance),
    toolsFrameworksList: jspb.Message.toObjectList(msg.getToolsFrameworksList(),
    proto.io.codedrills.proto.user.Skill.toObject, includeInstance),
    genericTechniquesList: jspb.Message.toObjectList(msg.getGenericTechniquesList(),
    proto.io.codedrills.proto.user.Skill.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Skills}
 */
proto.io.codedrills.proto.user.Skills.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Skills;
  return proto.io.codedrills.proto.user.Skills.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Skills} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Skills}
 */
proto.io.codedrills.proto.user.Skills.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.Skill;
      reader.readMessage(value,proto.io.codedrills.proto.user.Skill.deserializeBinaryFromReader);
      msg.addLanguageSkills(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.user.Skill;
      reader.readMessage(value,proto.io.codedrills.proto.user.Skill.deserializeBinaryFromReader);
      msg.addToolsFrameworks(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.user.Skill;
      reader.readMessage(value,proto.io.codedrills.proto.user.Skill.deserializeBinaryFromReader);
      msg.addGenericTechniques(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Skills.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Skills.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Skills} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Skills.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguageSkillsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.io.codedrills.proto.user.Skill.serializeBinaryToWriter
    );
  }
  f = message.getToolsFrameworksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.user.Skill.serializeBinaryToWriter
    );
  }
  f = message.getGenericTechniquesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.user.Skill.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Skill language_skills = 1;
 * @return {!Array<!proto.io.codedrills.proto.user.Skill>}
 */
proto.io.codedrills.proto.user.Skills.prototype.getLanguageSkillsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.Skill>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.Skill, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.Skill>} value
 * @return {!proto.io.codedrills.proto.user.Skills} returns this
*/
proto.io.codedrills.proto.user.Skills.prototype.setLanguageSkillsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.Skill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Skill}
 */
proto.io.codedrills.proto.user.Skills.prototype.addLanguageSkills = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.user.Skill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Skills} returns this
 */
proto.io.codedrills.proto.user.Skills.prototype.clearLanguageSkillsList = function() {
  return this.setLanguageSkillsList([]);
};


/**
 * repeated Skill tools_frameworks = 2;
 * @return {!Array<!proto.io.codedrills.proto.user.Skill>}
 */
proto.io.codedrills.proto.user.Skills.prototype.getToolsFrameworksList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.Skill>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.Skill, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.Skill>} value
 * @return {!proto.io.codedrills.proto.user.Skills} returns this
*/
proto.io.codedrills.proto.user.Skills.prototype.setToolsFrameworksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.Skill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Skill}
 */
proto.io.codedrills.proto.user.Skills.prototype.addToolsFrameworks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.user.Skill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Skills} returns this
 */
proto.io.codedrills.proto.user.Skills.prototype.clearToolsFrameworksList = function() {
  return this.setToolsFrameworksList([]);
};


/**
 * repeated Skill generic_techniques = 3;
 * @return {!Array<!proto.io.codedrills.proto.user.Skill>}
 */
proto.io.codedrills.proto.user.Skills.prototype.getGenericTechniquesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.Skill>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.Skill, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.Skill>} value
 * @return {!proto.io.codedrills.proto.user.Skills} returns this
*/
proto.io.codedrills.proto.user.Skills.prototype.setGenericTechniquesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.Skill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Skill}
 */
proto.io.codedrills.proto.user.Skills.prototype.addGenericTechniques = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.user.Skill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Skills} returns this
 */
proto.io.codedrills.proto.user.Skills.prototype.clearGenericTechniquesList = function() {
  return this.setGenericTechniquesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Skill.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Skill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Skill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Skill.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    verified: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Skill}
 */
proto.io.codedrills.proto.user.Skill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Skill;
  return proto.io.codedrills.proto.user.Skill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Skill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Skill}
 */
proto.io.codedrills.proto.user.Skill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Skill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Skill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Skill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Skill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.Skill.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Skill} returns this
 */
proto.io.codedrills.proto.user.Skill.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool verified = 2;
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Skill.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.user.Skill} returns this
 */
proto.io.codedrills.proto.user.Skill.prototype.setVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.Education.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Education.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Education.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Education} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Education.toObject = function(includeInstance, msg) {
  var f, obj = {
    degreesList: jspb.Message.toObjectList(msg.getDegreesList(),
    proto.io.codedrills.proto.user.Degree.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Education}
 */
proto.io.codedrills.proto.user.Education.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Education;
  return proto.io.codedrills.proto.user.Education.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Education} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Education}
 */
proto.io.codedrills.proto.user.Education.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.Degree;
      reader.readMessage(value,proto.io.codedrills.proto.user.Degree.deserializeBinaryFromReader);
      msg.addDegrees(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Education.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Education.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Education} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Education.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDegreesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.io.codedrills.proto.user.Degree.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Degree degrees = 1;
 * @return {!Array<!proto.io.codedrills.proto.user.Degree>}
 */
proto.io.codedrills.proto.user.Education.prototype.getDegreesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.Degree>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.Degree, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.Degree>} value
 * @return {!proto.io.codedrills.proto.user.Education} returns this
*/
proto.io.codedrills.proto.user.Education.prototype.setDegreesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.Degree=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Degree}
 */
proto.io.codedrills.proto.user.Education.prototype.addDegrees = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.user.Degree, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Education} returns this
 */
proto.io.codedrills.proto.user.Education.prototype.clearDegreesList = function() {
  return this.setDegreesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.Scopes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Scopes.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Scopes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Scopes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Scopes.toObject = function(includeInstance, msg) {
  var f, obj = {
    scopesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Scopes}
 */
proto.io.codedrills.proto.user.Scopes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Scopes;
  return proto.io.codedrills.proto.user.Scopes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Scopes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Scopes}
 */
proto.io.codedrills.proto.user.Scopes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<!proto.io.codedrills.proto.user.Scope>} */ (reader.readPackedEnum());
      msg.setScopesList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Scopes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Scopes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Scopes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Scopes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScopesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated Scope scopes = 1;
 * @return {!Array<!proto.io.codedrills.proto.user.Scope>}
 */
proto.io.codedrills.proto.user.Scopes.prototype.getScopesList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.user.Scope>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.Scope>} value
 * @return {!proto.io.codedrills.proto.user.Scopes} returns this
 */
proto.io.codedrills.proto.user.Scopes.prototype.setScopesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.user.Scope} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Scopes} returns this
 */
proto.io.codedrills.proto.user.Scopes.prototype.addScopes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Scopes} returns this
 */
proto.io.codedrills.proto.user.Scopes.prototype.clearScopesList = function() {
  return this.setScopesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Experience.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Experience.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Experience} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Experience.toObject = function(includeInstance, msg) {
  var f, obj = {
    company: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    start: jspb.Message.getFieldWithDefault(msg, 3, 0),
    end: jspb.Message.getFieldWithDefault(msg, 4, 0),
    location: jspb.Message.getFieldWithDefault(msg, 5, ""),
    description: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Experience}
 */
proto.io.codedrills.proto.user.Experience.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Experience;
  return proto.io.codedrills.proto.user.Experience.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Experience} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Experience}
 */
proto.io.codedrills.proto.user.Experience.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnd(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Experience.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Experience.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Experience} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Experience.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string company = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.Experience.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Experience} returns this
 */
proto.io.codedrills.proto.user.Experience.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.Experience.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Experience} returns this
 */
proto.io.codedrills.proto.user.Experience.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 start = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.Experience.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Experience} returns this
 */
proto.io.codedrills.proto.user.Experience.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 end = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.Experience.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Experience} returns this
 */
proto.io.codedrills.proto.user.Experience.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string location = 5;
 * @return {string}
 */
proto.io.codedrills.proto.user.Experience.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Experience} returns this
 */
proto.io.codedrills.proto.user.Experience.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.io.codedrills.proto.user.Experience.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Experience} returns this
 */
proto.io.codedrills.proto.user.Experience.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Degree.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Degree.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Degree} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Degree.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    school: jspb.Message.getFieldWithDefault(msg, 2, ""),
    field: jspb.Message.getFieldWithDefault(msg, 3, ""),
    start: jspb.Message.getFieldWithDefault(msg, 4, 0),
    end: jspb.Message.getFieldWithDefault(msg, 5, 0),
    grade: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Degree}
 */
proto.io.codedrills.proto.user.Degree.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Degree;
  return proto.io.codedrills.proto.user.Degree.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Degree} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Degree}
 */
proto.io.codedrills.proto.user.Degree.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchool(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnd(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrade(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Degree.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Degree.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Degree} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Degree.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSchool();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getGrade();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.Degree.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Degree} returns this
 */
proto.io.codedrills.proto.user.Degree.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string school = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.Degree.prototype.getSchool = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Degree} returns this
 */
proto.io.codedrills.proto.user.Degree.prototype.setSchool = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string field = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.Degree.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Degree} returns this
 */
proto.io.codedrills.proto.user.Degree.prototype.setField = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 start = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.Degree.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Degree} returns this
 */
proto.io.codedrills.proto.user.Degree.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 end = 5;
 * @return {number}
 */
proto.io.codedrills.proto.user.Degree.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Degree} returns this
 */
proto.io.codedrills.proto.user.Degree.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string grade = 6;
 * @return {string}
 */
proto.io.codedrills.proto.user.Degree.prototype.getGrade = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Degree} returns this
 */
proto.io.codedrills.proto.user.Degree.prototype.setGrade = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Preference.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Preference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Preference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Preference.toObject = function(includeInstance, msg) {
  var f, obj = {
    editorConfig: (f = msg.getEditorConfig()) && proto.io.codedrills.proto.user.EditorConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Preference}
 */
proto.io.codedrills.proto.user.Preference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Preference;
  return proto.io.codedrills.proto.user.Preference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Preference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Preference}
 */
proto.io.codedrills.proto.user.Preference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.EditorConfig;
      reader.readMessage(value,proto.io.codedrills.proto.user.EditorConfig.deserializeBinaryFromReader);
      msg.setEditorConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Preference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Preference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Preference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Preference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEditorConfig();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.user.EditorConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional EditorConfig editor_config = 1;
 * @return {?proto.io.codedrills.proto.user.EditorConfig}
 */
proto.io.codedrills.proto.user.Preference.prototype.getEditorConfig = function() {
  return /** @type{?proto.io.codedrills.proto.user.EditorConfig} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.EditorConfig, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.EditorConfig|undefined} value
 * @return {!proto.io.codedrills.proto.user.Preference} returns this
*/
proto.io.codedrills.proto.user.Preference.prototype.setEditorConfig = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Preference} returns this
 */
proto.io.codedrills.proto.user.Preference.prototype.clearEditorConfig = function() {
  return this.setEditorConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Preference.prototype.hasEditorConfig = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.EditorConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.EditorConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.EditorConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    theme: jspb.Message.getFieldWithDefault(msg, 1, ""),
    keyMap: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fontSize: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tabSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    autoComplete: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    language: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.EditorConfig}
 */
proto.io.codedrills.proto.user.EditorConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.EditorConfig;
  return proto.io.codedrills.proto.user.EditorConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.EditorConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.EditorConfig}
 */
proto.io.codedrills.proto.user.EditorConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyMap(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTabSize(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoComplete(value);
      break;
    case 6:
      var value = /** @type {!proto.io.codedrills.proto.judge.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.EditorConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.EditorConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.EditorConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKeyMap();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFontSize();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTabSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAutoComplete();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string theme = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.EditorConfig} returns this
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string key_map = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.getKeyMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.EditorConfig} returns this
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.setKeyMap = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string font_size = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.getFontSize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.EditorConfig} returns this
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.setFontSize = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 tab_size = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.getTabSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.EditorConfig} returns this
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.setTabSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool auto_complete = 5;
 * @return {boolean}
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.getAutoComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.user.EditorConfig} returns this
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.setAutoComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional io.codedrills.proto.judge.Language language = 6;
 * @return {!proto.io.codedrills.proto.judge.Language}
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.getLanguage = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Language} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @return {!proto.io.codedrills.proto.user.EditorConfig} returns this
 */
proto.io.codedrills.proto.user.EditorConfig.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.SubscriptionSettings.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.SubscriptionSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.SubscriptionSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SubscriptionSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    mailingListList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    subscriptionList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.SubscriptionSettings}
 */
proto.io.codedrills.proto.user.SubscriptionSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.SubscriptionSettings;
  return proto.io.codedrills.proto.user.SubscriptionSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.SubscriptionSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.SubscriptionSettings}
 */
proto.io.codedrills.proto.user.SubscriptionSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<!proto.io.codedrills.proto.user.MailingList>} */ (reader.readPackedEnum());
      msg.setMailingListList(value);
      break;
    case 2:
      var value = /** @type {!Array<!proto.io.codedrills.proto.user.SubscribeGroup>} */ (reader.readPackedEnum());
      msg.setSubscriptionList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.SubscriptionSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.SubscriptionSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SubscriptionSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMailingListList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getSubscriptionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
};


/**
 * repeated MailingList mailing_list = 1;
 * @return {!Array<!proto.io.codedrills.proto.user.MailingList>}
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.getMailingListList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.user.MailingList>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.MailingList>} value
 * @return {!proto.io.codedrills.proto.user.SubscriptionSettings} returns this
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.setMailingListList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.user.MailingList} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.SubscriptionSettings} returns this
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.addMailingList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.SubscriptionSettings} returns this
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.clearMailingListList = function() {
  return this.setMailingListList([]);
};


/**
 * repeated SubscribeGroup subscription = 2;
 * @return {!Array<!proto.io.codedrills.proto.user.SubscribeGroup>}
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.getSubscriptionList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.user.SubscribeGroup>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.SubscribeGroup>} value
 * @return {!proto.io.codedrills.proto.user.SubscriptionSettings} returns this
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.setSubscriptionList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.user.SubscribeGroup} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.SubscriptionSettings} returns this
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.addSubscription = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.SubscriptionSettings} returns this
 */
proto.io.codedrills.proto.user.SubscriptionSettings.prototype.clearSubscriptionList = function() {
  return this.setSubscriptionList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Activity.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Activity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Activity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Activity.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    url: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    version: jspb.Message.getFieldWithDefault(msg, 5, 0),
    activityStatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    data: (f = msg.getData()) && proto.io.codedrills.proto.user.ActivityData.toObject(includeInstance, f),
    createdOn: jspb.Message.getFieldWithDefault(msg, 8, 0),
    updatedOn: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Activity}
 */
proto.io.codedrills.proto.user.Activity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Activity;
  return proto.io.codedrills.proto.user.Activity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Activity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Activity}
 */
proto.io.codedrills.proto.user.Activity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 6:
      var value = /** @type {!proto.io.codedrills.proto.user.ActivityStatus} */ (reader.readEnum());
      msg.setActivityStatus(value);
      break;
    case 7:
      var value = new proto.io.codedrills.proto.user.ActivityData;
      reader.readMessage(value,proto.io.codedrills.proto.user.ActivityData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedOn(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Activity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Activity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Activity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Activity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getActivityStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.io.codedrills.proto.user.ActivityData.serializeBinaryToWriter
    );
  }
  f = message.getCreatedOn();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUpdatedOn();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.Activity.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
 */
proto.io.codedrills.proto.user.Activity.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.Activity.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
 */
proto.io.codedrills.proto.user.Activity.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_id = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.Activity.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
 */
proto.io.codedrills.proto.user.Activity.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.io.codedrills.proto.user.Activity.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
 */
proto.io.codedrills.proto.user.Activity.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 version = 5;
 * @return {number}
 */
proto.io.codedrills.proto.user.Activity.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
 */
proto.io.codedrills.proto.user.Activity.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional ActivityStatus activity_status = 6;
 * @return {!proto.io.codedrills.proto.user.ActivityStatus}
 */
proto.io.codedrills.proto.user.Activity.prototype.getActivityStatus = function() {
  return /** @type {!proto.io.codedrills.proto.user.ActivityStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.ActivityStatus} value
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
 */
proto.io.codedrills.proto.user.Activity.prototype.setActivityStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional ActivityData data = 7;
 * @return {?proto.io.codedrills.proto.user.ActivityData}
 */
proto.io.codedrills.proto.user.Activity.prototype.getData = function() {
  return /** @type{?proto.io.codedrills.proto.user.ActivityData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.ActivityData, 7));
};


/**
 * @param {?proto.io.codedrills.proto.user.ActivityData|undefined} value
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
*/
proto.io.codedrills.proto.user.Activity.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
 */
proto.io.codedrills.proto.user.Activity.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Activity.prototype.hasData = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 created_on = 8;
 * @return {number}
 */
proto.io.codedrills.proto.user.Activity.prototype.getCreatedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
 */
proto.io.codedrills.proto.user.Activity.prototype.setCreatedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 updated_on = 9;
 * @return {number}
 */
proto.io.codedrills.proto.user.Activity.prototype.getUpdatedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.Activity} returns this
 */
proto.io.codedrills.proto.user.Activity.prototype.setUpdatedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.ActivityData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.ActivityData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.ActivityData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ActivityData.toObject = function(includeInstance, msg) {
  var f, obj = {
    drillReport: (f = msg.getDrillReport()) && proto.io.codedrills.proto.user.DrillReport.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.ActivityData}
 */
proto.io.codedrills.proto.user.ActivityData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.ActivityData;
  return proto.io.codedrills.proto.user.ActivityData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.ActivityData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.ActivityData}
 */
proto.io.codedrills.proto.user.ActivityData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.io.codedrills.proto.user.DrillReport;
      reader.readMessage(value,proto.io.codedrills.proto.user.DrillReport.deserializeBinaryFromReader);
      msg.setDrillReport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.ActivityData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.ActivityData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.ActivityData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ActivityData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrillReport();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.user.DrillReport.serializeBinaryToWriter
    );
  }
};


/**
 * optional DrillReport drill_report = 2;
 * @return {?proto.io.codedrills.proto.user.DrillReport}
 */
proto.io.codedrills.proto.user.ActivityData.prototype.getDrillReport = function() {
  return /** @type{?proto.io.codedrills.proto.user.DrillReport} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.DrillReport, 2));
};


/**
 * @param {?proto.io.codedrills.proto.user.DrillReport|undefined} value
 * @return {!proto.io.codedrills.proto.user.ActivityData} returns this
*/
proto.io.codedrills.proto.user.ActivityData.prototype.setDrillReport = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.ActivityData} returns this
 */
proto.io.codedrills.proto.user.ActivityData.prototype.clearDrillReport = function() {
  return this.setDrillReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.ActivityData.prototype.hasDrillReport = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.DrillReport.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.DrillReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.DrillReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DrillReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    completedContentCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tracking: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.DrillReport}
 */
proto.io.codedrills.proto.user.DrillReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.DrillReport;
  return proto.io.codedrills.proto.user.DrillReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.DrillReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.DrillReport}
 */
proto.io.codedrills.proto.user.DrillReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompletedContentCount(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTracking(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.DrillReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.DrillReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.DrillReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DrillReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompletedContentCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTracking();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional int32 completed_content_count = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.DrillReport.prototype.getCompletedContentCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.DrillReport} returns this
 */
proto.io.codedrills.proto.user.DrillReport.prototype.setCompletedContentCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool tracking = 2;
 * @return {boolean}
 */
proto.io.codedrills.proto.user.DrillReport.prototype.getTracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.user.DrillReport} returns this
 */
proto.io.codedrills.proto.user.DrillReport.prototype.setTracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.ProblemReport.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.ProblemReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.ProblemReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ProblemReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.ProblemReport}
 */
proto.io.codedrills.proto.user.ProblemReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.ProblemReport;
  return proto.io.codedrills.proto.user.ProblemReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.ProblemReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.ProblemReport}
 */
proto.io.codedrills.proto.user.ProblemReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubmissionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.ProblemReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.ProblemReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.ProblemReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ProblemReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 submission_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.ProblemReport.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ProblemReport} returns this
 */
proto.io.codedrills.proto.user.ProblemReport.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.TestProblemScore.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.TestProblemScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.TestProblemScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TestProblemScore.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    submissionId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.TestProblemScore}
 */
proto.io.codedrills.proto.user.TestProblemScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.TestProblemScore;
  return proto.io.codedrills.proto.user.TestProblemScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.TestProblemScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.TestProblemScore}
 */
proto.io.codedrills.proto.user.TestProblemScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProblemScore(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubmissionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.TestProblemScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.TestProblemScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.TestProblemScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TestProblemScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemScore();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional double problem_score = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.TestProblemScore.prototype.getProblemScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TestProblemScore} returns this
 */
proto.io.codedrills.proto.user.TestProblemScore.prototype.setProblemScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional int32 submission_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.TestProblemScore.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TestProblemScore} returns this
 */
proto.io.codedrills.proto.user.TestProblemScore.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.user.ProfileChange.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.ProfileChange.ProfileChangeMessageCase = {
  PROFILE_CHANGE_MESSAGE_NOT_SET: 0,
  SCOREBOARD_COMPLETED: 1
};

/**
 * @return {proto.io.codedrills.proto.user.ProfileChange.ProfileChangeMessageCase}
 */
proto.io.codedrills.proto.user.ProfileChange.prototype.getProfileChangeMessageCase = function() {
  return /** @type {proto.io.codedrills.proto.user.ProfileChange.ProfileChangeMessageCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.user.ProfileChange.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.ProfileChange.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.ProfileChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.ProfileChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ProfileChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    scoreboardCompleted: (f = msg.getScoreboardCompleted()) && proto.io.codedrills.proto.user.ScoreboardCompleted.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.ProfileChange}
 */
proto.io.codedrills.proto.user.ProfileChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.ProfileChange;
  return proto.io.codedrills.proto.user.ProfileChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.ProfileChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.ProfileChange}
 */
proto.io.codedrills.proto.user.ProfileChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.ScoreboardCompleted;
      reader.readMessage(value,proto.io.codedrills.proto.user.ScoreboardCompleted.deserializeBinaryFromReader);
      msg.setScoreboardCompleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.ProfileChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.ProfileChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.ProfileChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ProfileChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScoreboardCompleted();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.user.ScoreboardCompleted.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScoreboardCompleted scoreboard_completed = 1;
 * @return {?proto.io.codedrills.proto.user.ScoreboardCompleted}
 */
proto.io.codedrills.proto.user.ProfileChange.prototype.getScoreboardCompleted = function() {
  return /** @type{?proto.io.codedrills.proto.user.ScoreboardCompleted} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.ScoreboardCompleted, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.ScoreboardCompleted|undefined} value
 * @return {!proto.io.codedrills.proto.user.ProfileChange} returns this
*/
proto.io.codedrills.proto.user.ProfileChange.prototype.setScoreboardCompleted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.io.codedrills.proto.user.ProfileChange.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.ProfileChange} returns this
 */
proto.io.codedrills.proto.user.ProfileChange.prototype.clearScoreboardCompleted = function() {
  return this.setScoreboardCompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.ProfileChange.prototype.hasScoreboardCompleted = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.ScoreboardCompleted.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.ScoreboardCompleted.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.ScoreboardCompleted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ScoreboardCompleted.toObject = function(includeInstance, msg) {
  var f, obj = {
    contestId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.ScoreboardCompleted}
 */
proto.io.codedrills.proto.user.ScoreboardCompleted.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.ScoreboardCompleted;
  return proto.io.codedrills.proto.user.ScoreboardCompleted.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.ScoreboardCompleted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.ScoreboardCompleted}
 */
proto.io.codedrills.proto.user.ScoreboardCompleted.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.ScoreboardCompleted.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.ScoreboardCompleted.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.ScoreboardCompleted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ScoreboardCompleted.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContestId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 contest_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.ScoreboardCompleted.prototype.getContestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ScoreboardCompleted} returns this
 */
proto.io.codedrills.proto.user.ScoreboardCompleted.prototype.setContestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.user.SendNewUserEmail.oneofGroups_ = [[3,5,6]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.InviteInfoCase = {
  INVITE_INFO_NOT_SET: 0,
  TEAM_ID: 3,
  TEST_ID: 5,
  CUSTOMER_ID: 6
};

/**
 * @return {proto.io.codedrills.proto.user.SendNewUserEmail.InviteInfoCase}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.getInviteInfoCase = function() {
  return /** @type {proto.io.codedrills.proto.user.SendNewUserEmail.InviteInfoCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.user.SendNewUserEmail.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.SendNewUserEmail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.SendNewUserEmail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SendNewUserEmail.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    password: jspb.Message.getFieldWithDefault(msg, 2, ""),
    teamId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    testId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    customerId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    newUser: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.SendNewUserEmail;
  return proto.io.codedrills.proto.user.SendNewUserEmail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.SendNewUserEmail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTestId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.user.NewUserType} */ (reader.readEnum());
      msg.setNewUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.SendNewUserEmail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.SendNewUserEmail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.SendNewUserEmail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getNewUser();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail} returns this
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail} returns this
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 team_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail} returns this
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.setTeamId = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.io.codedrills.proto.user.SendNewUserEmail.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail} returns this
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.clearTeamId = function() {
  return jspb.Message.setOneofField(this, 3, proto.io.codedrills.proto.user.SendNewUserEmail.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.hasTeamId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 test_id = 5;
 * @return {number}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.getTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail} returns this
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.setTestId = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.io.codedrills.proto.user.SendNewUserEmail.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail} returns this
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.clearTestId = function() {
  return jspb.Message.setOneofField(this, 5, proto.io.codedrills.proto.user.SendNewUserEmail.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.hasTestId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 customer_id = 6;
 * @return {number}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail} returns this
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.setCustomerId = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.io.codedrills.proto.user.SendNewUserEmail.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail} returns this
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.clearCustomerId = function() {
  return jspb.Message.setOneofField(this, 6, proto.io.codedrills.proto.user.SendNewUserEmail.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional NewUserType new_user = 4;
 * @return {!proto.io.codedrills.proto.user.NewUserType}
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.getNewUser = function() {
  return /** @type {!proto.io.codedrills.proto.user.NewUserType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.NewUserType} value
 * @return {!proto.io.codedrills.proto.user.SendNewUserEmail} returns this
 */
proto.io.codedrills.proto.user.SendNewUserEmail.prototype.setNewUser = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.NewUser.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.NewUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.NewUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.NewUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && proto.io.codedrills.proto.user.User.toObject(includeInstance, f),
    token: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.NewUser}
 */
proto.io.codedrills.proto.user.NewUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.NewUser;
  return proto.io.codedrills.proto.user.NewUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.NewUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.NewUser}
 */
proto.io.codedrills.proto.user.NewUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.user.User;
      reader.readMessage(value,proto.io.codedrills.proto.user.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.NewUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.NewUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.NewUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.NewUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.user.User.serializeBinaryToWriter
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional User user = 1;
 * @return {?proto.io.codedrills.proto.user.User}
 */
proto.io.codedrills.proto.user.NewUser.prototype.getUser = function() {
  return /** @type{?proto.io.codedrills.proto.user.User} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.User, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.User|undefined} value
 * @return {!proto.io.codedrills.proto.user.NewUser} returns this
*/
proto.io.codedrills.proto.user.NewUser.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.NewUser} returns this
 */
proto.io.codedrills.proto.user.NewUser.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.NewUser.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.NewUser.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.NewUser} returns this
 */
proto.io.codedrills.proto.user.NewUser.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.AdminRole = {
  UNKNOWN_ADMIN_ROLE: 0,
  ADMIN_ROLE_ADMIN: 1,
  ADMIN_ROLE_EDITOR: 2,
  ADMIN_ROLE_READER: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.CPVerificationType = {
  UNKNOWN_CP_VERIFICATION_TYPE: 0,
  CP_VERIFICATION_PROFILE_CHANGE: 1,
  CP_VERIFICATION_POST_COMMENT: 2,
  CP_VERIFICATION_SUBMIT_CODE: 3,
  CP_VERIFICATION_NAME_CHANGE: 4
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.CompetitiveSite = {
  UNKNOWN_COMPETITIVE_SITE: 0,
  CODEFORCES: 1,
  TOPCODER: 2,
  CODECHEF: 3,
  ATCODER: 4,
  SPOJ: 5,
  HACKEREARTH: 6,
  HACKERRANK: 7,
  ICPC: 8
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.SocialProfileType = {
  UNKNOWN_SOCIAL_SITE: 0,
  LINKEDIN: 1
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.Role = {
  UNKNOWN_USER_ROLE: 0,
  ADMIN: 1,
  USER: 2,
  SUPERADMIN: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.Scope = {
  BUILDER: 0
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.MailingList = {
  MAILING_LIST_UNSPECIFIED: 0,
  MAILING_LIST_ANNOUNCEMENT: 1
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.SubscribeGroup = {
  SUBSCRIBE_GROUP_UNSPECIFIED: 0,
  SUBSCRIBE_GROUP_CONTEST: 1,
  SUBSCRIBE_GROUP_INTERVIEW: 2,
  SUBSCRIBE_GROUP_GENERAL: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.ActivityStatus = {
  ACTIVITY_STATUS_UNSPECIFIED: 0,
  COMPLETED: 1,
  NOT_ATTEMPTED: 2,
  ATTEMPTED: 3,
  INVITED: 4
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.NewUserType = {
  NEW_USER_TYPE_UNSPECIFIED: 0,
  NEW_USER_CREATED: 1,
  NEW_USER_UNVERIFIED: 2,
  NEW_USER_VERIFIED: 3
};

goog.object.extend(exports, proto.io.codedrills.proto.user);
